export default {"src":"/_next/static/media/no-cost-img.13914f50.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};